import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  overtimeList: [], 
  overtimeArr: [],
  overtimeArray: [],
  overtimeID: '',
  selectedOvertime: null,
  selectedEmployee: null,
  selectedPolicy: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.overtimeList = [];
    state.overtimeArr = [];
    state.overtimeArray = [];
    state.overtimeID = "";
    state.selectedOvertime = null;
    state.selectedEmployee = null;
    state.selectedPolicy = null;
    state.isEditing = false;
  },
  SET_SELECTED_OVERTIME(state, overtimes) {
    state.selectedOvertime = overtimes;
    state.isEditing = true;
  },
  LIST_OVERTIMES(state, Overtimes) {
    state.overtimeList = Overtimes;
  },
  OVERTIMES_ARRAY(state, Overtimes){
    state.overtimeArray = Overtimes;
  },
  SET_SELECTED_POLICY(state, Overtimes) {
    state.selectedPolicy = Overtimes;
  },
  SET_SELECTED_EMPLOYEE(state, employee) {
    state.selectedEmployee = employee;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){

    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createEmployeeOvertime({ commit,state }, formData) {
    return axios.post('api/v1/create-employee-overtime/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchEmployeeOvertimes({ commit,state }, formData) {
    state.overtimeArr = [];
    axios.post(`api/v1/get-employee-overtimes/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.overtimeArr.push((response.data[i].overtime.name + " - " + response.data[i].employee.employee_name +" ("+ response.data[i].employee.staff_number +")"));
      }
      commit('LIST_OVERTIMES', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchEmployeeOvertime({ commit,state }, formData) {
    axios.post(`api/v1/get-employee-overtimes/`,formData)
    .then((response)=>{
      state.selectedOvertime = response.data;
      const selectedEmployee = response.data.employee.staff_number + " - " + response.data.employee.employee_name;
      const selectedPolicy = response.data.overtime_policy.name;
      commit('SET_SELECTED_OVERTIME',response.data);
      commit('SET_SELECTED_EMPLOYEE', selectedEmployee);
      commit('SET_SELECTED_POLICY', selectedPolicy);

    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedEmployeeOvertime({ commit, state }, option){
    const selectedOvertime = state.overtimeList.find(overtimes => (overtimes.overtime.name + " - " + overtimes.employee.employee_name +" ("+ overtimes.employee.staff_number +")") === option);
    if (selectedOvertime) {
        state.overtimeID = selectedOvertime.employee_overtime_id;
        state.overtimeArray = [...state.overtimeArray, selectedOvertime];
    }
    commit('OVERTIMES_ARRAY', state.overtimeArray);
      
  },

  async updateEmployeeOvertime({ commit,state }, formData) {
    return axios.put(`api/v1/update-employee-overtime/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteEmployeeOvertime({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Overtime?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Overtime!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-employee-overtime/`,formData)
        .then((response)=>{
          if(response.status == 200){
              Swal.fire("Poof! Overtime removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Overtime",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Overtime has not been deleted!`);
      }
    })
  },

};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  